import { render, staticRenderFns } from "./NonSubscriptionAccessCard.vue?vue&type=template&id=25aaf85c&scoped=true&"
import script from "./NonSubscriptionAccessCard.vue?vue&type=script&lang=ts&"
export * from "./NonSubscriptionAccessCard.vue?vue&type=script&lang=ts&"
import style0 from "./NonSubscriptionAccessCard.vue?vue&type=style&index=0&id=25aaf85c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25aaf85c",
  null
  
)

export default component.exports